import Font from '@maxpreps/shared/styles/font';
import React, { ReactNode } from 'react';
import styled from 'styled-components';
import THEME, { COLOR } from '../../../styles/colors';
import StyledText from '../../../ui/Text/StyledText';
import Anchor from '../../Anchor/Anchor';

const StyledLinkList = styled.ul<{ $hasRightBorder?: boolean }>`
  ${({ $hasRightBorder }) =>
    $hasRightBorder ? `border-right: 1px solid ${THEME.general.border};` : ''}

  & > li {
    & > a {
      display: block;
      padding: 8px 10px;
      margin: 0 10px;
      white-space: nowrap;

      &:hover {
        background-color: ${THEME.brand.maxpreps};
        color: ${COLOR.white};
        border-radius: 8px;
        margin: 0 10px;
      }
    }
  }
`;

interface SportSubLinksListProps {
  subItems: any[];
  header?: ReactNode;
  $hasRightBorder?: boolean;
}

const SportSubLinksList: React.FC<SportSubLinksListProps> = ({
  subItems,
  header,
  $hasRightBorder
}) => (
  <StyledLinkList $hasRightBorder={$hasRightBorder} className={Font.f14_tall}>
    {header && (
      <StyledText
        $fontWeight="bold"
        $color={THEME.text.primary}
        $padding="8px 20px"
        as="li"
        key="header"
      >
        {header}
      </StyledText>
    )}
    {subItems.map(item => (
      <li key={item.text}>
        <Anchor href={item.href} $color={THEME.text.tertiary}>
          {item.text}
        </Anchor>
      </li>
    ))}
  </StyledLinkList>
);

export default SportSubLinksList;
